"use strict";
angular.module("internal.exams").controller("InternalExamSessionStatus", ["$scope",
    "$state",
    "$stateParams",
    "EXSessionStatus",
    "EXFunctionAs",
    "$window",
    function ($scope, $state, $stateParams, EXSessionStatus, EXFunctionAs, $window) {
        $scope.SessionStatus = {
            active_status: true
        };
        $scope.saveMessage = $stateParams.saveMessage;
        if ($stateParams.examSessionStatusID != null) {
            EXSessionStatus.getsessionstatus($stateParams.examSessionStatusID).then(function (SessionStatus) {
                $scope.SessionStatus = SessionStatus;
                $scope.loading = false;
            });
        }
        EXFunctionAs.get().then(function (FunctionAsOpts) {
            $scope.FunctionAsOpts = FunctionAsOpts;
        });
        $scope.save = function () {
            $scope.saving = true;
            EXSessionStatus.save($scope.SessionStatus).then(function (SessionStatus) {
                $scope.saving = false;
                if (SessionStatus != null) {
                    $state.go("internal.exams.administrative.sessionstatus", { examSessionStatusID: SessionStatus.id, saveMessage: "Record updated successfully" });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };
        $scope.delete = function () {
            if ($scope.SessionStatus.numofsessions != null && $scope.SessionStatus.numofsessions > 0) {
                $scope.saveMessage = "Please re-assign the associated exam session(s) to a different status in order for deletion";
                $window.scrollTo(0, 0);
            } else {
                $scope.deleting = true;
                if (window.confirm("Are you sure you want to delete this skill category?")) {
                    EXSessionStatus.delete($scope.SessionStatus.id).then(function () {
                        $scope.deleting = false;
                        $state.go("internal.exams.administrative.sessionstatuses", {}, {
                            reload: "internal.exams.administrative.sessionstatuses"
                        });
                    });
                } else {
                    $scope.deleting = false;
                }
            }
        };
    }]);